export default {
      id: "icon--mail-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "./../Views/Shared/_SvgSprite.cshtml#icon--mail",
      toString: function () {
        return this.url;
      }
    }